import { Activity } from "lucide-react";
import { useNavigate } from "react-router-dom";
import bgLogo from "../assets/bg.svg";

function SignalAIThankYou() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen w-full flex items-center justify-center bg-gradient-hero px-4 py-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-mesh opacity-60 pointer-events-none" aria-hidden />
      <div className="relative w-full max-w-[520px] bg-card border border-border rounded-2xl shadow-elevated p-6 sm:p-8">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center gap-2.5 mb-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-dark">
              <Activity className="h-4 w-4 text-signal" strokeWidth={2.5} />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-base font-semibold tracking-tight text-foreground">Signal AI</span>
              <span className="inline-flex items-center gap-0">
                <span className="text-xs font-medium text-muted-foreground">by</span>
                <img src={bgLogo} alt="Gowitek" className="h-5 w-auto object-contain" />
              </span>
            </div>
          </div>

            <span className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 text-emerald-600 text-xs font-medium tracking-wide border border-emerald-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-3.5 w-3.5"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Assessment received
          </span>

          <h1 className="mt-3 text-3xl sm:text-4xl font-semibold text-slate-900 tracking-tight">
            Thank you.
          </h1>

       <p className="mt-3 text-sm sm:text-base text-slate-700 leading-relaxed max-w-[480px]">
We are curating the ROI-driven AI signals for you.  <br ></br> Your Signal AI report is on its way.</p>

          <div className="mt-4 w-full text-left relative overflow-hidden rounded-2xl border border-slate-800/60 bg-gradient-to-r from-[#020b1f] via-[#0a1833] to-[#111f39] p-5 shadow-elevated">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_10%,rgba(39,148,255,0.18),transparent_45%)]" aria-hidden />
            <div className="relative flex items-start gap-3">
              <div className="mt-0.5 h-7 w-7 rounded-lg bg-white border border-sky-100 flex items-center justify-center shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-4 w-4 text-sky-600"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4M12 8h.01" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-100">
                  This is not an automated score.
                </p>
                <p className="mt-1 text-sm text-slate-200 leading-relaxed">
                  Each response is reviewed to identify practical, ROI-driven
                  opportunities before recommending next steps.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-center gap-2 text-[11px] text-slate-400 tracking-wide uppercase">
            <div className="signal-chip mb-0 lowercase">
               consulting led • ai-first • roi driven
            </div>
          </div>
          <div className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-3 w-full">
            <a
              href="/"
              className="inline-flex items-center justify-center text-sm font-medium text-slate-500 hover:text-slate-700 transition"
            >
              Back to homepage
            </a>
          </div>

          <div className="mt-4 pt-3 border-t border-slate-100 w-full">
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignalAIThankYou;
